import { AppConfig } from '@ltvco/refresh-lib/ctx';
import { vehicleComplaints } from '@ltvco/refresh-lib/v2';
import { useQuery, UseQueryResult } from '@ltvco/refresh-lib/vendors';
import { useContext } from 'react';

export type VehicleComplaintsQueryData = {
  complaints?: any;
};

export const useVehicleComplaints = (
  year: string,
  make: string,
  model: string,
): UseQueryResult<VehicleComplaintsQueryData> => {
  const { logError } = useContext(AppConfig);

  return useQuery<VehicleComplaintsQueryData>({
    queryKey: ['vehicleComplaints', year, make, model],
    queryFn: async () => {
      const response = await vehicleComplaints(year, make, model);
      return response as VehicleComplaintsQueryData;
    },
    enabled: Boolean(year) && Boolean(make) && Boolean(model),
    onError: (error) => {
      logError('Error fetching vehicle complaints', error as Error);
    },
  });
};
